import React from "react";
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import Flex from "../common/Flex";
import ButtonIcon from "../common/ButtonIcon";
import { faInfoCircle, faUndo } from "@fortawesome/free-solid-svg-icons";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { getStallDetails } from "../../helpers/api/parking";
import { useHistory, useParams } from "react-router-dom";
import useSWRFetch from "../../helpers/hooks/useSWRFetch";
import moment from "moment";

const MyStallsDetails = () => {
  const history = useHistory();
  const { id } = useParams();

  const { data, error, isLoading } = useSWRFetch(id, getStallDetails);

  return (
    <>
      <PageHeader
        title="Estacionamiento"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
        description={
          "Si necesitas ayuda comunicanos, nuestra finalidad es ayudar a los usuarios para que puedan resolver inconvenientes."
        }
      />
      <Card>
        <CardHeader>
          <h5>Detalle del parqueo</h5>
        </CardHeader>
        <CardBody className="bg-light">
          <PreloadState cond={!!data?.data} loading={isLoading}>
            <Or value={true}>
              <Row>
                <Col xs={12} tag={FormGroup}>
                  <Label>Puesto</Label>
                  <Label className="form-control">
                    {data?.data.propertyParkingLot.acronym}-
                    {data?.data.propertyParkingLot.property_parking_id}
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} tag={FormGroup}>
                  <Label>Fecha de creación</Label>
                  <Label className="form-control">
                    {moment(data?.data.propertyParkingLot.created_at).format(
                      "DD/MM/YYYY [a las] h:mm A"
                    )}
                  </Label>
                </Col>
                <Col xs={12} md={6} tag={FormGroup}>
                  <Label>Fecha de actualización</Label>
                  <Label className="form-control">
                    {moment(data?.data.propertyParkingLot.updated_at).format(
                      "DD/MM/YYYY [a las] h:mm A"
                    )}
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col xs={12} tag={FormGroup}>
                  <Label className="mr-2">Estado</Label>
                  {!!data?.data.propertyParkingLot.available === "0" ? (
                    <Badge color="soft-danger" pill>
                      Ocupado
                    </Badge>
                  ) : (
                    <Badge color="soft-success" pill>
                      Disponible
                    </Badge>
                  )}
                </Col>
                {data?.data.propertyParkingLot.available === 0 &&
                  data?.data.propertyParkingLot.description && (
                    <Col xs={12} tag={FormGroup}>
                      <Label>
                        Placa o identificación del vehículo que lo ocupa
                      </Label>
                      <Label className="form-control">
                        {data?.data.propertyParkingLot.description}
                      </Label>
                    </Col>
                  )}
              </Row>
            </Or>
            <Or value={false} cond={!!error}>
              <Message
                className="p-3"
                value={true}
                color={"danger"}
                icon={faInfoCircle}
              >
                Hubo un error al cargar los datos!
              </Message>
              <Message
                className="p-3"
                value={false}
                color={"info"}
                icon={faInfoCircle}
              >
                No hay datos para mostrar
              </Message>
            </Or>
          </PreloadState>
        </CardBody>
        <CardFooter>
          <Flex align="center" justify="end">
            <ButtonIcon
              disabled={isLoading}
              color="light"
              className="px-5 mr-2"
              size="md"
              onClick={() => history.goBack()}
              icon={faUndo}
            >
              Volver
            </ButtonIcon>
          </Flex>
        </CardFooter>
      </Card>
    </>
  );
};

export default MyStallsDetails;
